import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Tooltip,
  InputAdornment,
  OutlinedInput,
  FormControl,
  InputLabel,
  Box,
} from "@material-ui/core";

import { Add as AddIcon } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import React, { useEffect, useState } from "react";
import rest from "../../rest";
import CustomEditorDropdown from "./CustomEditorDropdown";
import { makeStyles } from "@material-ui/core/styles";
import ShareIcon from "@material-ui/icons/Share";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import EditionModele from "../../components/contactBenevoles/modal/EditionModele";
import ConfirmDeleteModal from "../../components/contactBenevoles/modal/ConfirmDeleteModal";

import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  tabsContainer: {
    backgroundColor: "#f1f1f1",
    borderRadius: theme.shape.borderRadius,
  },
  tab: {
    minWidth: 100,
    color: "#555",
  },
  tabSelected: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: theme.shape.borderRadius,
  },

  formControl: {
    backgroundColor: "white",
    "&.Mui-focused .MuiSelect-root": {
      backgroundColor: "white",
    },
  },
}));

const ModelCourierModifiable = ({
  setMessage,
  closeModal,
  setRefresh,
  setModeleValue,
  refresh,
  handleModel: handleModelProp,
}) => {
  const [modeleData, setModeleData] = useState([]);
  const [message, setModifiableMessage] = useState("");
  const [messagePapier, setModifiableMessagePapier] = useState("");
  const [creePar, setCreePar] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [localRefresh, setLocalRefresh] = useState(false);
  const [selectedModelID, setSelectedModelID] = useState(0);
  const [actionModel, setActionModel] = useState("");
  const currentUser = useSelector((state) => state.user);

  const classes = useStyles();

  const [openModalRemoveModele, setOpenModalRemoveModele] = useState(false);
  const [openModalEditionModele, setOpenModalEditionModele] = useState(false);

  const stripHtmlTags = (str) => {
    if (!str) return "";
    return str.replace(/<\/?[^>]+(>|$)/g, "");
  };

  useEffect(() => {
    const fetchData = () => {
      rest
        .post("/benevols/modelescouriersmodifiables.json")
        .then((response) => {
          const cleanedModels = response.data?.Modeles.map((model) => ({
            ...model,
            name: stripHtmlTags(model.name),
          }));
          setModeleData(cleanedModels);
        })
        .catch((error) => {
          console.error(
            "Une erreur s'est produite lors de la récupération des Modeles :",
            error
          );
        });
    };

    fetchData();
  }, [localRefresh]);

  useEffect(() => {
    if (selectedModelID === 0) return;
    setSelectedModelID(selectedModelID);
  }, [selectedModelID]);

  const handleModelSelect = (modelId) => {
    setSelectedModelID(modelId);
    const model = modeleData.find((model) => model.id === modelId) || null;
    if (model) {
      setModifiableMessage(model.contenu || "");
      setModifiableMessagePapier(model.contenuPapier || "");
      setCreePar(model.createur || "");
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCreateModel = () => {
    setActionModel("create");
    setOpenModalEditionModele(true);
  };

  const handleEditModel = () => {
    setActionModel("edit");
    setOpenModalEditionModele(true);
  };

  const handleDeleteModel = () => {
    setOpenModalRemoveModele(true);
  };

  const handleCloseModalEditionModele = () => {
    setOpenModalEditionModele(false);
  };

  const handleCloseModalRemoveModele = () => {
    setOpenModalRemoveModele(false);
  };

  const updateModel = () => {
    const formData = new FormData();
    formData.append("vId", selectedModelID);
    formData.append("vMessage", message);
    formData.append("vMessagePapier", messagePapier);
    formData.append("vAction", "modifier");

    rest
      .post("/benevols/enregistrerModelescouriers.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.error === false) {
          setModeleValue(selectedModelID);
          setMessage(message);
          closeModal();
          setRefresh((prev) => !prev);
        }
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la modification du modèle :",
          error
        );
      });
  };

  console.log(modeleData);

  return (
    <>
      <EditionModele
        action={actionModel}
        open={openModalEditionModele}
        handleClose={handleCloseModalEditionModele}
        modelId={selectedModelID}
        setSelectedModelID={setSelectedModelID}
        setRefresh={setLocalRefresh}
      />
      <ConfirmDeleteModal
        open={openModalRemoveModele}
        handleClose={handleCloseModalRemoveModele}
        modelId={selectedModelID}
        setSelectedModelID={setSelectedModelID}
        modelName={
          modeleData.find((model) => model.id === selectedModelID)?.name
        }
        setRefresh={setLocalRefresh}
      />
      <Grid container spacing={2} alignItems="center" style={{ padding: 16 }}>
        <Grid item xs={12}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel htmlFor="modele-select">Modèle</InputLabel>
            <Select
              fullWidth
              value={selectedModelID}
              onChange={(e) => handleModelSelect(e.target.value)}
              input={
                <OutlinedInput
                  label="Modèle"
                  className={classes.formControl}
                  endAdornment={
                    <InputAdornment position="end">
                      <Box display="flex" alignItems="center">
                        <Box
                          display="flex"
                          sx={{
                            marginRight: 16,
                            "& .MuiIconButton-root": {
                              padding: "4px",
                              "& svg": { fontSize: "24px" },
                            },
                          }}
                        >
                          {selectedModelID > 0 &&
                            modeleData.find(
                              (model) => model.id === selectedModelID
                            )?.createurID === currentUser.User.User_ID && (
                              <>
                                <Tooltip title="Editer le modèle" arrow>
                                  <IconButton onClick={handleEditModel}>
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Supprimer le modèle" arrow>
                                  <IconButton onClick={handleDeleteModel}>
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                          <Tooltip title="Ajouter un modèle" arrow>
                            <IconButton onClick={handleCreateModel}>
                              <AddIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </InputAdornment>
                  }
                />
              }
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
            >
              <MenuItem value={0}>
                <em>Sélectionnez un modèle</em>
              </MenuItem>

              {modeleData &&
                modeleData.map((model) => (
                  <MenuItem key={model.id} value={model.id}>
                    <Box display="flex" alignItems="center">
                      <Box display="flex">
                        {model.partage ? (
                          <Tooltip title="Partagé" arrow>
                            <ShareIcon style={{ color: "#346185" }} />
                          </Tooltip>
                        ) : (
                          <span style={{ marginRight: 19 }}>&nbsp;</span>
                        )}
                        {model.actif ? (
                          <Tooltip title="Actif" arrow>
                            <CheckCircleIcon
                              style={{ color: "#346185", marginRight: 16 }}
                            />
                          </Tooltip>
                        ) : (
                          <span style={{ marginRight: 19 + 19 }}>&nbsp;</span>
                        )}
                      </Box>
                      <span>{model.name}</span>
                    </Box>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Box mt={2}>
            <span>Modèle créé par : {creePar}</span>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box className={classes.tabsContainer}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              centered={false}
              style={{ marginBottom: -16, paddingBottom: 0 }}
            >
              <Tab
                label="Version email"
                className={classes.tab}
                classes={{ selected: classes.tabSelected }}
              />
              <Tab
                label="Version papier"
                className={classes.tab}
                classes={{ selected: classes.tabSelected }}
              />
            </Tabs>
          </Box>
        </Grid>

        <Grid item xs={12}>
          {tabValue === 0 && (
            <CustomEditorDropdown
              message={message}
              setMessage={setModifiableMessage}
            />
          )}
          {tabValue === 1 && (
            <CustomEditorDropdown
              message={messagePapier}
              setMessage={setModifiableMessagePapier}
            />
          )}
        </Grid>
        <Grid container item xs={12} justifyContent="flex-end">
          <Button
            onClick={updateModel}
            type="submit"
            variant="contained"
            color="secondary"
          >
            Valider
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default ModelCourierModifiable;
